import { CommonModule, DatePipe, NgOptimizedImage } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnChanges, inject } from '@angular/core';
import { Comment } from '../../../admin/shared/public-api';
import { DeviceService } from '../../../shared/services/device.service';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss'],
  imports: [CommonModule, DatePipe, NgOptimizedImage],
})
export class CommentComponent implements OnChanges {
  @Input() comment: Comment;
  @Input() isFirst: boolean;
  @Input() isLast: boolean;
  @Output() onAnswerComment: EventEmitter<string> = new EventEmitter();
  protected deviceService = inject(DeviceService);

  isExplorateurs: boolean;
  avatar: string;

  ngOnChanges(): void {
    this.generateAvatar();
  }

  answerComment(response: Comment | null = null): void {
    if (response) {
      this.onAnswerComment.emit(response.id);
    } else {
      this.onAnswerComment.emit(this.comment.id);
    }
  }

  generateAvatar(): void {
    const name = this.comment.name;
    if (name.toLowerCase() === 'les explorateurs du monde') {
      this.isExplorateurs = true;
      return;
    }

    if (name.length === 1) {
      this.avatar = name;
      return;
    }

    const words = name.split(' ');
    if (words.length === 1) {
      this.avatar = name.slice(0, 2);
      return;
    }

    this.avatar = `${words[0][0]}${words[1][0]}`;
  }
}
